module.exports = __webpack_public_path__ + "static/media/day.44f76bdb.png";